/* eslint-disable camelcase */
import React from 'react';
import PlacePerksWrapper from '../styles/PlacePerkBanner.style';
import SmallStar from '../molecules/SmallStar';
// import CheckMark from '../molecules/CheckMark';
import { PAGE_VARIANTS } from '../PlacePerkConstants';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../utils/labels/labelUtilty';
import labelsObj, { ACCOUNT_OVERVIEW } from '../../../account/PlacePerks/PlacePerks.labels';

const PlacePerkBanner = ({
  perkLevel,
  spendLeftForNextPerk,
  cartTotal,
  pageVariant,
  orderTotal,
  displayThreshold,
  // offerList,
  currentPerkLevel,
}) => {
  const placePerkLabels = getLabelFromCopyOrFromTranslation(ACCOUNT_OVERVIEW, labelsObj);
  const reachedNewLevel =
    pageVariant === PAGE_VARIANTS.CONFIMRATION_PAGE
      ? orderTotal >= spendLeftForNextPerk
      : cartTotal >= spendLeftForNextPerk;

  const includeCartSpendLeftNextPerk = (spendLeftForNextPerk - cartTotal).toFixed(2);
  // TODO : Dynamic labels
  const congratsLabelText = renderLabel(
    placePerkLabels.lbl_placeperk_congrats_short,
    'lbl_placeperk_congrats_short'
  );
  const bannerStatus = renderLabel(
    placePerkLabels.lbl_place_perk_bag_banner_status,
    'lbl_place_perk_bag_banner_status'
  );

  const spendMoreToUnlockTxt = () => {
    const text = renderLabel(
      getDynamicLabelValues('dynamic.account_d.lbl_place_perk_bag_banner'),
      'lbl_place_perk_bag_banner'
    );
    const [partOne = '', partTwo = ''] = text.split('#spendLeftForNextPerk#');
    return (
      <span>
        {partOne}
        <b>${includeCartSpendLeftNextPerk}</b>
        {partTwo}
      </span>
    );
  };

  const unlockedNewPerkLevelMessage = () => {
    return (
      <div className="new-perk-level-message">
        <div className="text-line-with-icon">
          <span>
            {renderLabel(
              placePerkLabels.lbl_place_perk_banner_unlock,
              'lbl_place_perk_banner_unlock'
            )}
          </span>
          <span className="injected-value"> MY PLACE REWARDS </span>
          <span>
            {renderLabel(
              placePerkLabels.lbl_place_perk_banner_order_ship,
              'lbl_place_perk_banner_order_ship'
            )}
          </span>
        </div>
      </div>
    );
  };

  if (currentPerkLevel === perkLevel) {
    return null;
  }

  if (reachedNewLevel) {
    // buying will upgrade level
    // const rewards = getRewards(offerList);
    // const numPerkRows = Math.ceil(rewards.length / 2);
    // const displayPerk = (perkMsg, ind) => (
    //   <div key={ind} className="text-line-with-icon">
    //     <CheckMark />
    //     <span>{perkMsg}</span>
    //   </div>
    // );

    return (
      <PlacePerksWrapper pageVariant={pageVariant} perkLevel={'nextPerkLevel'}>
        <div className="frame frame-level-up">
          <div className="label injected-value">{`${congratsLabelText}!`}</div>
          <div className="level-up-content">
            {unlockedNewPerkLevelMessage()}
            {/* <div className="new-perks-content">
              <div className="new-perks-column">
                {rewards.slice(0, numPerkRows).map((p, ind) => displayPerk(p, ind))}
              </div>
              <div className="new-perks-column">
                {rewards.slice(numPerkRows).map((p, ind) => displayPerk(p, ind))}
              </div>
            </div> */}
          </div>
        </div>
      </PlacePerksWrapper>
    );
  }

  // not leveling up
  if (includeCartSpendLeftNextPerk < displayThreshold) {
    return (
      <PlacePerksWrapper pageVariant={pageVariant}>
        <div className="frame frame-status">
          <div className="text-line-with-icon">
            {bannerStatus}
            <SmallStar perkLevel={perkLevel} />
            <span className="injected-value">{perkLevel}</span>
          </div>
          <div className="text-line-with-icon">{spendMoreToUnlockTxt()}</div>
        </div>
      </PlacePerksWrapper>
    );
  }

  // return nothing if doesn't meet above cases
  return <></>;
};

export default PlacePerkBanner;
export { PlacePerkBanner as PlacePerkBannerVanilla };
